import DarkModeSwitch from "./DarkModeSwitch";
const { Component } = wp.element;

class DarkModeSwitchSelector extends Component {
    state = {
        value: this.props.value,
    };

    render() {
        const styles = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

        const isLocked = switchId => !wp_dark_mode_admin_json.is_ultimate && switchId > 3;

        return (
            <div className="wp-dark-mode-switches-panel">
                <div className="wp-dark-mode-switches cols-2">
                    {styles.map(style => (
                        <div className={`wp-dark-mode-switches-item wp-dark-mode-ignore ${style === this.props.value ? 'active' : ''} ${ isLocked ( style ) ? 'disabled' : ''}`}
                            onClick={() => {

                                if ( isLocked ( style ) ) {
                                    if ('WPDarkModePromo' in window) {
                                        window.WPDarkModePromo.show();
                                    }
                                    return;
                                }
                                this.props.onChange(style)
                            }}>
                            <DarkModeSwitch size={style === 6 ? '0.5' : '0.8'} style={style.toString()} />

                            { isLocked ( style ) && (
                                <div className="wp-dark-mode-switches-item-lock pointer-events-none wp-dark-mode-ignore">
                                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="23" height="23" rx="11.5" fill="white" />
                                        <path d="M14.7498 9.55H9.5498V8.25C9.5498 7.73 9.7448 7.275 10.1348 6.885C10.9148 6.105 12.1498 6.105 12.8648 6.885C13.1248 7.145 13.2548 7.47 13.3848 7.795C13.4498 8.12 13.8398 8.315 14.1648 8.25C14.4898 8.185 14.7498 7.795 14.6198 7.47C14.4898 6.885 14.1648 6.365 13.7748 5.975C13.1898 5.325 12.3448 5 11.4998 5C9.6798 5 8.2498 6.43 8.2498 8.25V9.55C7.1448 9.55 6.2998 10.395 6.2998 11.5V16.05C6.2998 17.155 7.1448 18 8.2498 18H14.7498C15.8548 18 16.6998 17.155 16.6998 16.05V11.5C16.6998 10.395 15.8548 9.55 14.7498 9.55ZM12.1498 14.75C12.1498 15.14 11.8898 15.4 11.4998 15.4C11.1098 15.4 10.8498 15.14 10.8498 14.75V12.8C10.8498 12.41 11.1098 12.15 11.4998 12.15C11.8898 12.15 12.1498 12.41 12.1498 12.8V14.75Z" fill="#FB923C" />
                                    </svg>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default DarkModeSwitchSelector;